import { Typography } from "@mui/material";
import CrmIntegrationSelect from "../../components/CrmIntegrationSelect";

export default ({
  actionParameters,
  setActionParameters,
  setValidForm,
  getToken,
  companyId,
}: {
  actionParameters: any;
  setActionParameters: (p: any) => void;
  setValidForm: (b: boolean) => void;
  getToken: () => Promise<string>;
  companyId: string;
}) => {
  return (
    <div>
      <div style={{ marginTop: "24px" }}>
        <CrmIntegrationSelect
          value={actionParameters.crmIntegrationId || ""}
          onChange={(integrationId) =>
            setActionParameters({
              ...actionParameters,
              crmIntegrationId: integrationId,
            })
          }
          getToken={getToken}
          companyId={companyId}
          showTooltip={true}
          tooltipText="Select which CRM to search for existing contacts. The action will check if each row's contact already exists in the CRM."
          helperText="Select the CRM to search for existing contacts"
          required={true}
          onValidationChange={setValidForm}
        />
      </div>

      <div style={{ marginTop: "24px" }}>
        <Typography variant="subtitle1">How Matching Works</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          The lookup will try to find existing contacts using these fields (in
          order of priority):
        </Typography>
        <ul
          style={{
            marginTop: "8px",
            paddingLeft: "20px",
            color: "text.secondary",
          }}
        >
          <li>
            <strong>Email</strong> - Primary match (exact match)
          </li>
          <li>
            <strong>Phone</strong> - Secondary match (normalized comparison)
          </li>
          <li>
            <strong>Name + Company</strong> - Fuzzy match when email/phone not
            available
          </li>
        </ul>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2, fontStyle: "italic" }}
        >
          Results will show whether a match was found and include the CRM record
          ID if available.
        </Typography>
      </div>
    </div>
  );
};
